module.exports = __webpack_public_path__ + "static/media/DryFruits Cookies 300 g.cb0bc61b.jpg";